module.exports = __webpack_public_path__ + "img/booker_meet.8b108232.png";